import { useState, useEffect } from 'react';
import axios from 'utils/axios';

const EventAdminDetailService = async (id) => {
    const [data, setData] = useState([]);

    // useEffect()
    // await axios.get('api/event/'+id).then(response => setData(response.data)).catch(error => {
    //   console.log(error);
    // });

    const getData = async (url, action) => {
        await axios.get(url + id).then((response) => {
            console.log(response.data);
            action(response.data);
        });
    };
    useEffect(() => {
        getData('api/event/', setData);
    }, []);

    return { data };
};

export default EventAdminDetailService;
